(ns frontend.view.settings.components.image-uploader
  (:require [common.localization :as loc]
            [frontend.utils :as fu]
            [clojure.string :as string]
            [ui.components.button.view :as button]))

(defn photo [{:keys [show-title? picture-url css-class key label on-remove!]}]
  (let [missing-kw (keyword (str "missing-" (name key)))
        picture-url (fu/only-https-or-relative-img picture-url)]
    [:div
     {:class-name (str "settings-company2__photo-container" css-class)}
     (when show-title?
       [:label.settings-company2__field-label.text-left label])
     [:div.dropzone-wrapper
      (if-not (string/blank? picture-url)
        [:div
         {:class-name (str "settings-company2__photo " css-class)
          :style      {:background-image (str "url(" (fu/sanitize-img-url picture-url) ")")}}]
        [:div.settings-company2__photo
         {:class-name (str "settings-company2__photo " css-class)}
         [:p.settings-company2__photo-label (loc/tr missing-kw)]])
      (when on-remove!
        [:span.remove-upload [:i.fal.fa-times-circle
                              {:on-click on-remove!}]])]]))

(defn remove-file [{:keys [show-title? remove-button-text css-class key label on-remove!]}]
  [:div
   {:class-name (str "settings-company2__remove-file-container" css-class)}
   (when show-title?
     [:label.settings-company2__field-label.text-left.mr-3 label])
   [button/sm-secondary-hollow
    {:on-click   on-remove!}
    remove-button-text]])

(defn image-view []
  (let [input-id (str "input-id-" (gensym))]
    (fn [{:keys [edit? hide-preview? show-title? id value edit-value key label
                 remove-button-text on-change on-remove! img-size css-class]}]
      (if edit?
        [:form
         {:action     "/api/attachment"
          :class-name (str "file-dropzone")}
         (when show-title?
           [:label.settings-company2__field-label label])
         [:div.fallback
          [:div.dropzone-instructions
           [:span.text-2xl
            [:i.fal.fa-cloud-upload]]
           [:span
            (loc/tr :dropzone-instructions-pre-link)]
           [:span.dropzone-instructions-link
            (loc/tr :dropzone-instructions-link)]
           

           [:span.dropzone-info-text
            (when img-size
              (loc/tr :dropzone-recommended-image-size [img-size]))]]
          [:input
           {:type      "file"
            :on-focus  (fn [e]
                         (.preventDefault e)
                         (.setTimeout js/window (fn []
                                                  (.blur (.getElementById js/document input-id))) 300)
                         false)
            :id        input-id
            :on-change on-change}]]]
        (if hide-preview?
          [remove-file {:show-title?        show-title?
                        :remove-button-text remove-button-text
                        :css-class          css-class
                        :picture-url        value
                        :on-remove!         on-remove!
                        :key                key
                        :label              label}]
          [photo {:show-title? show-title?
                  :css-class   css-class
                  :picture-url value
                  :on-remove!  on-remove!
                  :key         key
                  :label       label}])))))
